import { render, staticRenderFns } from "./conteudoBotao.vue?vue&type=template&id=83f19bd6&scoped=true"
import script from "./conteudoBotao.vue?vue&type=script&lang=js"
export * from "./conteudoBotao.vue?vue&type=script&lang=js"
import style0 from "./conteudoBotao.vue?vue&type=style&index=0&id=83f19bd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f19bd6",
  null
  
)

export default component.exports